import React, { useState } from "react";
import { deploymentLinkHost, mainAddressFor } from "./appUpdate.js";

// Shown only on Cloudflare Pages' one-off deployment links, which never receive updates.
export default function OldLinkBanner() {
  const host = deploymentLinkHost();
  const [hidden, setHidden] = useState(() => { try { return sessionStorage.getItem("bb-oldlink") === "1"; } catch (e) { return false; } });
  if (!host || hidden) return null;
  const main = mainAddressFor(host);
  return (
    <div className="fixed top-0 inset-x-0 z-[60] px-4 py-2.5 text-xs leading-snug flex items-start gap-3" style={{ background: "var(--brass)", color: "var(--ink)", paddingTop: "calc(env(safe-area-inset-top, 0px) + 10px)" }}>
      <span className="flex-1">This is a one-off test link and will never update. Open <a href={`https://${main}`} className="underline font-semibold">{main}</a> and install the app from there.</span>
      <button onClick={() => { try { sessionStorage.setItem("bb-oldlink", "1"); } catch (e) { /* ignore */ } setHidden(true); }} aria-label="Dismiss" className="font-semibold">OK</button>
    </div>
  );
}
